import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Almond.css";

export default function Almond() {
    const almondProducts = [
        {
            id: 1,
            name: "CALIFORNIA ALMONDS",
            image: "/assets/img/Almonds/California-Almonds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Bakery and confectionery products",
                        "Healthy snack mixes",
                        "Almond milk production",
                        "Protein-rich food products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Uniform size and quality",
                        "Rich in protein and fiber",
                        "Excellent shelf life",
                        "High global demand",
                    ],
                },
            ],
        },

        {
            id: 2,
            name: "MAMRA ALMONDS",
            image: "/assets/img/Almonds/Mamra-Almonds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Premium dry fruit packs",
                        "Health supplements",
                        "Traditional Ayurvedic diets",
                        "Daily nutrition consumption",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Naturally rich in oils",
                        "Premium quality almond variety",
                        "High nutritional value",
                        "Excellent taste and texture",
                    ],
                },
            ],
        },

        {
            id: 3,
            name: "GURBANDI ALMONDS",
            image: "/assets/img/Almonds/Gurbandi-Almonds.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Healthy snack products",
                        "Dry fruit mixtures",
                        "Traditional food preparations",
                        "Nutritional diets",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Rich antioxidant content",
                        "Distinctive flavor",
                        "High nutrient density",
                        "Popular health food choice",
                    ],
                },
            ],
        },

        {
            id: 4,
            name: "ALMOND KERNELS",
            image: "/assets/img/Almonds/Almond-Kernels.jpg",
            usage: [
                {
                    title: "Where It's Used",
                    points: [
                        "Food processing industries",
                        "Bakery products",
                        "Chocolate manufacturing",
                        "Nut-based products",
                    ],
                },
                {
                    title: "Why It's Used",
                    points: [
                        "Ready-to-use form",
                        "High nutritional value",
                        "Versatile food ingredient",
                        "Excellent taste and crunch",
                    ],
                },
            ],
        },

    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Polypropylene_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Breadcrumb
                title="Almond (Badam)"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Almond Product Range</h1>

                    <p className="pp-subtitle">
                        Explore our premium quality Almond (Badam) products sourced from
                        trusted suppliers worldwide.
                    </p>

                    <div className="pp-grid">
                        {almondProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>

                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>

                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div
                            className="modal-overlay"
                            onClick={() => setSelectedProduct(null)}
                        >
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />

                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>

                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    className="close-btn"
                                    onClick={() => setSelectedProduct(null)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}